__turbopack_context__.v({
  "moreInfoBtn": "styles-module-scss-module__VjV3Rq__moreInfoBtn",
  "moreInfoBtnIcon": "styles-module-scss-module__VjV3Rq__moreInfoBtnIcon",
});
